// extracted by mini-css-extract-plugin
export var colorSquare = "_qz-0";
export var danger = "_qz-5";
export var lightPink = "_qz-8";
export var neutralBlue = "_qz-7";
export var neutralYellow = "_qz-6";
export var normal = "_qz-1";
export var primary = "_qz-2";
export var primaryLight = "_qz-3";
export var solidBlack = "_qz-g";
export var solidGreen = "_qz-b";
export var solidLightBlue = "_qz-d";
export var solidNavy = "_qz-c";
export var solidOrange = "_qz-f";
export var solidPink = "_qz-e";
export var solidRed = "_qz-9";
export var solidYellow = "_qz-a";
export var success = "_qz-4";